export default 'removalRequestsPage';
